import React, { useState } from 'react'
import Stepper from '../Stepper/Stepper'
import Navbar from '../../Navbar/Navbar'
import "./PartyDetails.css"
import {useLocation, useNavigate} from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { partBookingDetails } from '../../../../Redux/Slice/AuthSlice'

const PartyDetails = () => {
  const [formData,setFormData] = useState({
    partyName:"",
    numberOfGuest:"",
    firstName:"",
    lastName:"",
    phone:"",
    email:"",
    textarea:"",
    waiver:""
  })
  const navigate = useNavigate()
  const location = useLocation()
  const {auth_info} = useSelector((state)=>state.Auth)
  const dispatch = useDispatch()
  const dataSlot = location.state

  const handleForm = (e)=>{
    const {name,value} = e.target
    setFormData((prev)=>({...prev,[name]:value}))
  }

  const handleDetail = ()=>{
    dispatch(partBookingDetails(JSON.stringify({data:formData,message:'detail'})))
    navigate('/portal/booking/party/summary',{state:dataSlot})
  }
  return (
    <div className="kiga-portal-package-main">
      <Navbar />

      <div className="kiga-portal-package-head-title">
        <p>Party Booking</p>
      </div>

      <Stepper />

      <section className='kiga-portal-package-section'>

        <div className='kiga-portal-package-section-title'>
          <h5>Step 5</h5>
          <p>Other Party Details</p>
        </div>

        {/* PARTY */}
        <div className='kiga-portal-detail-other-section-back'>
          <div className='kiga-portal-detail-other-section-title'>
            <p>Party</p>
          </div>

          <div className='kiga-portal-detail-other-section-grid'>

            <div className="kiga-portal-detail-other-section-grid-flex">
              <div className="kiga-portal-detail-other-section-grid-section-label">
                <label>Name of Party:<span>*</span></label>
              </div>

              <div className="kiga-portal-detail-other-section-grid-input">
                <input type="text" name="partyName" value={`${auth_info?.name} Family`} onChange={handleForm}/>
                <div><label>(ex. "Morris Family" or "Jaguars Baseball Team")</label></div>
              </div>
            </div>

            <div className="kiga-portal-detail-other-section-grid-flex">
              <div className="kiga-portal-detail-other-section-grid-section-label">
                <label>Number of Guests:<span>*</span></label>
              </div>

              <div className="kiga-portal-detail-other-section-grid-input">
                <input type="number" name="numberOfGuest" onChange={handleForm}/>
                <div><label>Maximum capacity: 30</label></div>
              </div>
            </div>

          </div>
        </div>

        {/* CONTACT */}
        <div className='kiga-portal-detail-other-section-back'>
          <div className='kiga-portal-detail-other-section-title'>
            <p>Contact</p>
            <span>Who should we contact with any information regarding this party?</span>
          </div>

          <div className='kiga-portal-detail-other-section-grid'>

            <div className="kiga-portal-detail-other-section-grid-flex">
              <div className="kiga-portal-detail-other-section-grid-section-label">
                <label>Name:<span>*</span></label>
              </div>

              <div className="kiga-portal-detail-other-section-grid-input">
                <input type="text" placeholder="First Name" name="firstName" defaultValue="" onChange={handleForm} />
                <div><label>First Name</label></div>
              </div>

              <div className="kiga-portal-detail-other-section-grid-input">
                <input type="text" placeholder="Last Name" name="lastName" defaultValue="" onChange={handleForm}/>
                <div><label>Last Name</label></div>
              </div>
            </div>

            <div className="kiga-portal-detail-other-section-grid-flex">
              <div className="kiga-portal-detail-other-section-grid-section-label">
                <label>Phone:<span>*</span></label>
              </div>

              <div className="kiga-portal-detail-other-section-grid-input">
                <input type="tel" name="phone" defaultValue="" onChange={handleForm} />
              </div>
            </div>

            <div className="kiga-portal-detail-other-section-grid-flex">
              <div className="kiga-portal-detail-other-section-grid-section-label">
                <label>Email:<span>*</span></label>
              </div>

              <div className="kiga-portal-detail-other-section-grid-input">
                <input type="email" name="email" value={auth_info?.email} onChange={handleForm}/>
              </div>
            </div>

          </div>
        </div>

        {/* GUEST */}
        <div className='kiga-portal-detail-other-section-back'>
          <div className='kiga-portal-detail-other-section-title'>
            <p>Guest(s) of Honor</p>
            <span>The most important guest(s) at an occasion.</span>
          </div>

          <div className="kiga-portal-detail-other-section-btn">
            <button>Add Guest Honor</button>
          </div>
        </div>

        {/* ADDITIONAL */}
        <div className='kiga-portal-detail-other-section-back'>
          <div className='kiga-portal-detail-other-section-title'>
            <p>Additional Information</p>
            <span>Let us know of any special needs or any information regarding your order.</span>
          </div>

          <textarea className="kiga-textarea" rows="4" name='textarea' onChange={handleForm}></textarea>
        </div>

        {/* WAIVER */}
        <div className='kiga-portal-detail-other-section-back'>
          <div className='kiga-portal-detail-other-section-title'>
            <p>Agree to waiver requirement</p>
          </div>

          <div className="kiga-portal-checkbox-row">
            <input type="checkbox" id="waiver" name='waiver' onChange={handleForm}/>

            <label htmlFor="waiver">
              I understand that EACH guest must have a waiver signed and turned in before they can participate.
              In the case of minors, a parent or guardian must complete and sign the waiver.
            </label>
          </div>
        </div>

        <button className="kiga-submit-btn" onClick={handleDetail}>Continue</button>

      </section>
    </div>
  )
}

export default PartyDetails